import { createContext } from 'react';

export const CreditIconAnimationContext = createContext<boolean>(false);

export default CreditIconAnimationContext;
